import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { htmlEscaper, token } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n<div class=\"campaign-properties-section\">\r\n</div>\r\n\r\n<div id=\"security-benefits-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":12,"column":46},"end":{"line":12,"column":60}}}))
    + "\"></div>";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row show-for-medium-up\">\r\n  <div class=\"column small-12\">\r\n    <h2 class=\"cnx-light\" tabindex=\"0\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n  </div>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"column small-12 medium-10 medium-offset-1 large-12 large-offset-0 benefits-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"benefits") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":2},"end":{"line":29,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"switch") : depth0),"YES",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":2},"end":{"line":28,"column":14}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"additionalOption") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":2},"end":{"line":27,"column":9}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"benefit\">\r\n    <div class=\"benefit-container\">\r\n      <div class=\"image-container\">\r\n        <img src=\""
    + ((stack1 = (lookupProperty(helpers,"token")||(depth0 && lookupProperty(depth0,"token"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"imagePath") : depth0),(depths[1] != null ? lookupProperty(depths[1],"campaignProperties") : depths[1]),{"name":"token","hash":{},"data":data,"loc":{"start":{"line":20,"column":18},"end":{"line":20,"column":66}}})) != null ? stack1 : "")
    + "\" alt=\"\">\r\n      </div>\r\n      <div class=\"benefit-content\">\r\n        "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"additionalOption") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":32,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/security-benefits-cc-module",
  "version": "5.0.1",
  "id": "securityBenefitsCcModule",
  "containerID": "creditCardsSecurityBenefitsCcModule",
  "moduleName": "credit-cards-security-benefits-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "security-benefits-cc-module",
  "data": {
    "init": "securityBenefitsCcModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        compare,
        json,
        htmlEscaper,
        token
      },
      "partials": {
        "security-benefits-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "security-benefits-cc-partial": renderTemplate
  },
  "helpers": {
    compare,
    json,
    htmlEscaper,
    token
  },
  "dependencies": {
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* global spaParams */

/**
 * security-benefits-cc-module
 * module_js_id: securityBenefitsCcModuleJS
 *
 * Copyright (c) 2017-12-4 Tyler Frega
 */

/**
 * @class securityBenefitsCcModuleJS
 * @extends Module
 */
class securityBenefitsCcModuleJS extends Module {
  /**
   * Constructor
   * @param {*} options options
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.content = JSON.parse(target.querySelector('#security-benefits-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['security-benefits-cc-partial'];
    const magellanDest = target.dataset.init.substr(0, target.dataset.init.length - 2);
    target.dataset.magellanDestination = magellanDest;
  }

  /**
   * @returns {void}
   */
  init() {
    let campaignProperties;
    this.Events.sub('campaignProperties-spartaStore', data => {
      campaignProperties = data.data.data;
      const campaign = this.Store.getData('campaign');
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);
      const {
        target
      } = this.settings;
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        content: linkContent,
        site: spaParams.siteParams
      });
      target.querySelector('.campaign-properties-section').innerHTML = renderedTemplate;
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });

      /* links should open language-change interstitial - links returned from productProperties
      does not have data-options to pop the modal - adding manually here */
      const isSpanish = this.Store.getData('lang') === 'es-us';
      if (isSpanish) {
        this.addSpanishInterstitialLearnMore();
      }

      /** ADA fix :-
      * To convey the user for links that opens in a new window/tab
      */
      [...target.querySelectorAll("a[target='_blank']")].forEach(link => {
        if (link.innerText === this.content.securityCenter.text) {
          link.insertAdjacentHTML('beforeend', this.content.securityCenter.adaText);
        }
      });

      /** Function calls :- 
      * Adding descriptive text to Learn more links 
      * To get rid of space issues 
      */
      this.addDescriptiveTextLearnMore(this.content.ficoScore.existingAdaText, this.content.ficoScore.newAdaText, this.content.ficoScore.headingText);
      this.addDescriptiveTextLearnMore(this.content.contactlessChipTechnology.existingAdaText, this.content.contactlessChipTechnology.newAdaText, this.content.contactlessChipTechnology.headingText);
      this.addDescriptiveTextLearnMore(this.content.digitalWalletTechnology.existingAdaText, this.content.digitalWalletTechnology.newAdaText, this.content.digitalWalletTechnology.headingText);
    });
  }

  /* 
  * Adding descriptive text to Learn more links 
  * To get rid of space issues 
  */
  addDescriptiveTextLearnMore(existingAdaText, JCRContent, headingText) {
    const learnMoreLink = document.getElementsByClassName('boa-fn-ool');
    Array.from(learnMoreLink).filter(element => element.textContent === existingAdaText).forEach(element => {
      element.hasAttribute('title') && element.removeAttribute('title');
      element.insertAdjacentHTML('beforeend', JCRContent);
      [...element.childNodes].filter(childNode => childNode.textContent === headingText).forEach(childNode => {
        childNode.remove();
      });
    });
  }

  /**
   * @returns { void }
   * adds interstitial language change modal functionality to the learn-more links
   */
  addSpanishInterstitialLearnMore() {
    const learnMoreLinks = Array.from(this.settings.target.querySelectorAll('.es-layer-link'));
    learnMoreLinks.forEach(link => {
      // Have to add multiple classes via multiple calls due to IE
      link.classList.add('spa-ui-layer-link');
      link.classList.add('spa-fn');
      // eslint-disable-next-line no-param-reassign
      link.dataset.options = JSON.stringify({
        interstitialType: 'language-change',
        interstitialBranding: 'default',
        targetAction: 'new-tab'
      });
    });
  }
}
registerModuleClass({
  moduleClass: securityBenefitsCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { securityBenefitsCcModuleJS as default, moduleConfig };
